export enum DsaStatus {
  REQUESTED = 'REQUESTED',
  IN_REVIEW = 'IN_REVIEW',
  VERIFIED = 'VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  VERIFICATION_REFUSED = 'VERIFICATION_REFUSED',
  VERIFICATION_EXPIRED = 'VERIFICATION_EXPIRED',
  PENDING = 'PENDING',
}
